module.exports = __webpack_public_path__ + "static/img/logos_220px_webank.a4f2e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/network/logos_220px_webank.png
// module id = Cj+w
// module chunks = 0